// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
:host {
  display: block;
  min-width: 0;
  color: var(--ca-text-primary, #172033);
}

.breadcrumb {
  margin: 1.25rem 1.5rem 0;
}

.breadcrumb-nav {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0 0 0.75rem;
  color: var(--ca-text-tertiary, #6f7b91);
  font-size: 0.875rem;
}

.breadcrumb-current {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  color: var(--ca-text-secondary, #4b5870);
  font-weight: 500;
}

.breadcrumb-current i {
  color: var(--ca-primary, #0e2e80);
  font-size: 1.25rem;
}

.asset-config-page {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  margin: 0 auto;
  padding: 1rem 1.5rem 1.75rem;
}

.page-header, .list-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1.25rem;
  margin-bottom: 1.25rem;
}

.page-heading {
  min-width: 0;
}

.page-heading h1 {
  margin: 0 0 0.35rem;
  color: var(--ca-text-primary, #172033);
  font-size: clamp(1.4rem, 2vw, 1.8rem);
  font-weight: 700;
  letter-spacing: -0.025em;
  line-height: 1.3;
}

.page-heading p, .list-heading p {
  margin: 0;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.9rem;
  line-height: 1.55;
}

.page-header-meta {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 0.75rem;
  min-width: 10.5rem;
  padding: 0.7rem 0.9rem;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: var(--ca-radius-md, 8px);
  background: var(--ca-surface, #fff);
  box-shadow: var(--ca-shadow-sm, 0 2px 6px rgba(7, 17, 46, 0.06));
}

.header-meta-icon {
  display: grid;
  width: 2.4rem;
  height: 2.4rem;
  flex: 0 0 2.4rem;
  place-items: center;
  border-radius: var(--ca-radius-sm, 6px);
  background: var(--ca-surface-active, #eef3ff);
  color: var(--ca-primary, #0e2e80);
  font-size: 1.1rem;
}

.page-header-meta > div {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.page-header-meta strong {
  color: var(--ca-text-primary, #172033);
  font-size: 1.1rem;
  line-height: 1.2;
}

.page-header-meta span:not(.header-meta-icon) {
  color: var(--ca-text-tertiary, #6f7b91);
  font-size: 0.72rem;
  white-space: nowrap;
}

.asset-list-card {
  min-width: 0;
  padding: 1.25rem;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: var(--ca-radius-lg, 12px);
  background: var(--ca-surface, #fff);
  box-shadow: var(--ca-shadow-sm, 0 2px 6px rgba(7, 17, 46, 0.06));
}

.list-heading {
  align-items: center;
}

.section-eyebrow {
  margin-bottom: 0.35rem;
  color: var(--ca-primary-light, #2850ad);
  font-size: 0.68rem;
  font-weight: 800;
  letter-spacing: 0.1em;
}

.list-heading h2 {
  margin: 0 0 0.3rem;
  color: var(--ca-text-primary, #172033);
  font-size: 1.15rem;
  font-weight: 700;
}

.btn-primary, .btn-secondary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  min-height: 2.6rem;
  padding: 0.65rem 1rem;
  border-radius: var(--ca-radius-md, 8px);
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.25;
  white-space: nowrap;
  transition: background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;
}

.btn-primary {
  border: 1px solid var(--ca-primary, #0e2e80);
  background: var(--ca-primary, #0e2e80);
  color: #fff;
}

.btn-primary:hover:not(:disabled) {
  border-color: var(--ca-primary-dark, #0d2863);
  background: var(--ca-primary-dark, #0d2863);
  color: #fff;
}

.btn-secondary {
  border: 1px solid var(--ca-border, #dfe4ec);
  background: var(--ca-surface, #fff);
  color: var(--ca-primary, #0e2e80);
}

.btn-secondary:hover:not(:disabled) {
  border-color: var(--ca-primary, #0e2e80);
  background: var(--ca-surface-hover, #f8faff);
}

.btn-primary:focus-visible, .btn-secondary:focus-visible {
  outline: 3px solid rgba(40, 80, 173, 0.25);
  outline-offset: 2px;
}

.btn-primary:disabled, .btn-secondary:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.search-toolbar {
  display: grid;
  grid-template-columns: minmax(16rem, 1.5fr) minmax(13rem, 0.85fr) auto;
  gap: 0.75rem;
  margin-bottom: 1.1rem;
}

.search-field {
  display: flex;
  min-width: 0;
  align-items: stretch;
}

.search-control {
  width: 100%;
  min-width: 0;
  min-height: 2.65rem;
  border: 1px solid var(--ca-input-border, #dfe4ec);
  border-radius: var(--ca-radius-md, 8px);
  background: var(--ca-input-bg, #fff);
  color: var(--ca-text-primary, #172033);
  font-size: 0.875rem;
}

.search-control:focus {
  border-color: var(--ca-input-focus, #2850ad);
  box-shadow: 0 0 0 0.2rem rgba(40, 80, 173, 0.15);
  outline: 0;
}

.search-control::placeholder {
  color: var(--ca-text-muted, #8c96a8);
}

.search-field .search-control {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.search-submit {
  display: inline-grid;
  width: 2.75rem;
  flex: 0 0 2.75rem;
  place-items: center;
  border: 1px solid var(--ca-primary, #0e2e80);
  border-radius: 0 var(--ca-radius-md, 8px) var(--ca-radius-md, 8px) 0;
  background: var(--ca-primary, #0e2e80);
  color: #fff;
  cursor: pointer;
}

.search-submit:hover {
  background: var(--ca-primary-dark, #0d2863);
}

.clear-search {
  align-self: stretch;
}

.table-region {
  min-width: 0;
  overflow-x: auto;
}

.table-region app-main-table {
  display: block;
  min-width: 0;
}

.inline-loading {
  display: flex;
  min-height: 4.5rem;
  align-items: center;
  gap: 0.65rem;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.875rem;
}

.inline-error {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin: 0.75rem 0;
  padding: 0.85rem 1rem;
  border: 1px solid var(--ca-danger, #dc3545);
  border-radius: var(--ca-radius-md, 8px);
  background: var(--ca-danger-bg, #fdecef);
  color: var(--ca-text-primary, #172033);
  font-size: 0.85rem;
}

.inline-retry {
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--ca-primary, #0e2e80);
  font-weight: 700;
  text-decoration: underline;
  cursor: pointer;
}

.state-panel, .no-results, .empty-state {
  display: flex;
  min-height: 15rem;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.65rem;
  padding: 2rem 1rem;
  color: var(--ca-text-tertiary, #6f7b91);
  text-align: center;
}

.state-panel > i, .no-results > i {
  color: var(--ca-primary-light, #2850ad);
  font-size: 2rem;
}

.state-panel h2, .no-results h3, .empty-state h2 {
  margin: 0;
  color: var(--ca-text-primary, #172033);
  font-size: 1.15rem;
  font-weight: 700;
}

.state-panel p, .no-results p, .empty-state p {
  max-width: 35rem;
  margin: 0 0 0.5rem;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.9rem;
  line-height: 1.6;
}

.error-state > i {
  color: var(--ca-danger, #dc3545);
}

.empty-state {
  min-height: min(60vh, 40rem);
}

.empty-state-content {
  width: min(100%, 42rem);
  text-align: center;
}

.empty-state-icon {
  display: grid;
  width: 4.25rem;
  height: 4.25rem;
  place-items: center;
  margin: 0 auto 1.25rem;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: 1.25rem;
  background: var(--ca-surface-active, #eef3ff);
  color: var(--ca-primary, #0e2e80);
  font-size: 2rem;
}

.empty-state h2 {
  margin-bottom: 0.65rem;
  font-size: clamp(1.35rem, 2.5vw, 1.75rem);
}

.empty-state p {
  margin: 0 auto 1.5rem;
}

.empty-state-action {
  min-height: 2.85rem;
  padding-inline: 1.25rem;
}

.loading-spinner {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  border: 3px solid var(--ca-border, #dfe4ec);
  border-top-color: var(--ca-primary, #0e2e80);
  border-radius: 50%;
  animation: data-config-spin 0.8s linear infinite;
}

.loading-spinner-sm {
  width: 1.1rem;
  height: 1.1rem;
  border-width: 2px;
}

.list-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-top: 1.15rem;
  padding-top: 1rem;
  border-top: 1px solid var(--ca-border-light, #e9edf3);
}

.pagination-summary {
  color: var(--ca-text-tertiary, #6f7b91);
  font-size: 0.78rem;
}

@keyframes data-config-spin {
  to {
    transform: rotate(360deg);
  }
}
@media (max-width: 1100px) {
  .list-heading {
    align-items: flex-start;
    flex-direction: column;
  }
  .search-toolbar {
    grid-template-columns: minmax(0, 1fr) minmax(12rem, 0.8fr);
  }
  .clear-search {
    grid-column: 1/-1;
    justify-self: start;
  }
}
@media (max-width: 767.98px) {
  .breadcrumb {
    margin: 0.75rem 1rem 0;
  }
  .asset-config-page {
    padding: 0.75rem 1rem 1.25rem;
  }
  .page-header {
    align-items: flex-start;
    flex-direction: column;
  }
  .asset-list-card {
    padding: 0.875rem;
  }
  .search-toolbar {
    grid-template-columns: minmax(0, 1fr);
  }
  .clear-search {
    grid-column: auto;
    justify-self: start;
  }
  .list-footer {
    align-items: stretch;
    flex-direction: column;
  }
  .list-footer app-pagination {
    align-self: flex-end;
    max-width: 100%;
  }
}
@media (prefers-reduced-motion: reduce) {
  *, *::before, *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    scroll-behavior: auto !important;
    transition-duration: 0.01ms !important;
  }
}
/* =========================================================
   DATA ASSET DETAILS — RIGHT-SIDE SLIDE PANEL
   Uses the global Consult-AI design tokens from styles.scss.
   ========================================================= */
.asset-details-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1090;
  display: block;
  width: 100%;
  height: 100%;
  padding: 0;
  border: 0;
  background: rgba(4, 27, 56, 0.48);
  opacity: 0;
  visibility: hidden;
  cursor: default;
  transition: opacity 0.24s ease, visibility 0.24s ease;
}

.asset-details-backdrop.is-open {
  opacity: 1;
  visibility: visible;
}

.asset-details-drawer {
  position: fixed;
  z-index: 1091;
  top: 0;
  right: 0;
  bottom: 0;
  display: flex;
  width: min(600px, 100vw);
  max-width: 100%;
  flex-direction: column;
  overflow: hidden;
  border-left: 1px solid var(--ca-border-light, #e9edf3);
  background: var(--ca-surface, #fff);
  box-shadow: -14px 0 42px rgba(7, 17, 46, 0.18);
  transform: translateX(105%);
  visibility: hidden;
  transition: transform 0.28s cubic-bezier(0.2, 0.75, 0.25, 1), visibility 0.28s ease;
}

.asset-details-drawer.is-open {
  transform: translateX(0);
  visibility: visible;
}

.drawer-header {
  display: flex;
  flex: 0 0 auto;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  padding: 1.35rem 1.4rem 1.1rem;
  border-bottom: 1px solid var(--ca-border-light, #e9edf3);
  background: linear-gradient(180deg, #fff 0%, #fbfcff 100%);
}

.drawer-heading {
  display: flex;
  min-width: 0;
  align-items: flex-start;
  gap: 0.85rem;
}

.drawer-heading-icon {
  display: grid;
  width: 2.8rem;
  height: 2.8rem;
  flex: 0 0 2.8rem;
  place-items: center;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: 0.8rem;
  background: var(--ca-surface-active, #eef3ff);
  color: var(--ca-primary, #0e2e80);
  font-size: 1.2rem;
}

.drawer-eyebrow {
  margin: 0 0 0.25rem;
  color: var(--ca-primary-light, #2850ad);
  font-size: 0.64rem;
  font-weight: 800;
  letter-spacing: 0.12em;
}

.drawer-heading h2 {
  margin: 0 0 0.25rem;
  color: var(--ca-text-primary, #172033);
  font-size: 1.22rem;
  font-weight: 750;
}

.drawer-subtitle {
  margin: 0;
  color: var(--ca-text-tertiary, #6f7b91);
  font-size: 0.78rem;
  line-height: 1.45;
}

.drawer-close {
  display: grid;
  width: 2.35rem;
  height: 2.35rem;
  flex: 0 0 2.35rem;
  place-items: center;
  border: 1px solid var(--ca-border, #dfe4ec);
  border-radius: 0.65rem;
  background: #fff;
  color: var(--ca-text-secondary, #4b5870);
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease;
}

.drawer-close:hover {
  border-color: var(--ca-primary, #0e2e80);
  background: var(--ca-surface-active, #eef3ff);
  color: var(--ca-primary, #0e2e80);
}

.drawer-body {
  min-height: 0;
  flex: 1 1 auto;
  overflow-y: auto;
  padding: 1.15rem 1.35rem 1.5rem;
}

.drawer-state {
  display: flex;
  min-height: 14rem;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.65rem;
  padding: 1.5rem;
  color: var(--ca-text-secondary, #4b5870);
  text-align: center;
}

.drawer-state > strong {
  color: var(--ca-text-primary, #172033);
  font-size: 0.95rem;
}

.drawer-state p {
  max-width: 20rem;
  margin: 0;
  color: var(--ca-text-tertiary, #6f7b91);
  font-size: 0.82rem;
  line-height: 1.5;
}

.drawer-state-icon {
  display: grid;
  width: 3rem;
  height: 3rem;
  place-items: center;
  margin-bottom: 0.2rem;
  border-radius: 1rem;
  background: var(--ca-danger-bg, #fdecef);
  color: var(--ca-danger, #dc3545);
  font-size: 1.3rem;
}

.drawer-state h3 {
  margin: 0;
  color: var(--ca-text-primary, #172033);
  font-size: 1rem;
  font-weight: 700;
}

.details-hero {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  align-items: start;
  gap: 0.85rem;
  padding: 1rem;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: var(--ca-radius-lg, 12px);
  background: linear-gradient(135deg, #f8faff, #fff 80%);
}

.asset-avatar {
  display: grid;
  width: 2.65rem;
  height: 2.65rem;
  place-items: center;
  border-radius: 0.8rem;
  background: var(--ca-surface-active, #eef3ff);
  color: var(--ca-primary, #0e2e80);
  font-size: 1.25rem;
}

.details-hero-copy {
  min-width: 0;
}

.details-hero-copy h3 {
  margin: 0.1rem 0 0.35rem;
  color: var(--ca-text-primary, #172033);
  font-size: 1.05rem;
  font-weight: 750;
  overflow-wrap: anywhere;
}

.details-hero-copy p {
  margin: 0;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.82rem;
  line-height: 1.55;
  overflow-wrap: anywhere;
}

.configuration-status-badge {
  grid-column: 2;
  justify-self: start;
  padding: 0.32rem 0.65rem;
  border-radius: 999px;
  font-size: 0.68rem;
  font-weight: 750;
  letter-spacing: 0.025em;
}

.configuration-status-badge.configured {
  background: var(--ca-success-bg, #eaf7f0);
  color: var(--ca-success, #198754);
}

.configuration-status-badge.not-configured {
  background: var(--ca-warning-bg, #fff7e6);
  color: #9a6500;
}

.details-section {
  margin-top: 1.15rem;
  padding: 1.05rem;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: var(--ca-radius-lg, 12px);
  background: var(--ca-surface, #fff);
}

.details-section-heading {
  display: flex;
  align-items: center;
  gap: 0.7rem;
  margin-bottom: 0.9rem;
}

.details-section-icon {
  display: grid;
  width: 2.1rem;
  height: 2.1rem;
  flex: 0 0 2.1rem;
  place-items: center;
  border-radius: 0.65rem;
  background: var(--ca-surface-active, #eef3ff);
  color: var(--ca-primary, #0e2e80);
  font-size: 0.95rem;
}

.details-section-heading h3 {
  margin: 0 0 0.15rem;
  color: var(--ca-text-primary, #172033);
  font-size: 0.9rem;
  font-weight: 750;
}

.details-section-heading p {
  margin: 0;
  color: var(--ca-text-tertiary, #6f7b91);
  font-size: 0.73rem;
}

.details-metric-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.75rem;
}

.detail-metric {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 0.4rem;
  padding: 0.85rem;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: var(--ca-radius-md, 8px);
  background: var(--ca-bg, #f5f7fb);
}

.detail-metric span {
  color: var(--ca-text-tertiary, #6f7b91);
  font-size: 0.75rem;
  font-weight: 600;
}

.detail-metric strong {
  color: var(--ca-primary, #0e2e80);
  font-size: 1.35rem;
  line-height: 1.2;
  overflow-wrap: anywhere;
}

.details-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0 0.9rem;
  margin: 0;
}

.detail-item {
  min-width: 0;
  padding: 0.72rem 0;
  border-bottom: 1px solid var(--ca-border-light, #e9edf3);
}

.detail-item:nth-last-child(-n+2) {
  border-bottom: 0;
}

.detail-item dt {
  margin-bottom: 0.3rem;
  color: var(--ca-text-tertiary, #6f7b91);
  font-size: 0.7rem;
  font-weight: 600;
}

.detail-item dd {
  margin: 0;
  color: var(--ca-text-primary, #172033);
  font-size: 0.82rem;
  font-weight: 650;
  line-height: 1.45;
  overflow-wrap: anywhere;
}

.detail-item-wide {
  grid-column: 1/-1;
}

.detail-item-wide:nth-last-child(-n+2) {
  border-bottom: 1px solid var(--ca-border-light, #e9edf3);
}

.detail-id {
  color: var(--ca-text-secondary, #4b5870) !important;
  font-size: 0.73rem !important;
  font-weight: 500 !important;
  word-break: break-all;
}

.drawer-footer {
  display: flex;
  flex: 0 0 auto;
  justify-content: flex-end;
  padding: 0.85rem 1.35rem;
  border-top: 1px solid var(--ca-border-light, #e9edf3);
  background: #fff;
}

.drawer-footer .btn {
  min-width: 6rem;
}

@media (max-width: 575.98px) {
  .asset-details-drawer {
    width: 100vw;
  }
  .drawer-header {
    padding: 1rem;
  }
  .drawer-body {
    padding: 0.9rem;
  }
  .drawer-footer {
    padding: 0.8rem 0.9rem;
  }
  .details-section {
    padding: 0.85rem;
  }
  .details-grid {
    grid-template-columns: minmax(0, 1fr);
  }
  .detail-item:nth-last-child(-n+2) {
    border-bottom: 1px solid var(--ca-border-light, #e9edf3);
  }
  .detail-item:last-child {
    border-bottom: 0;
  }
  .detail-item-wide {
    grid-column: auto;
  }
  .detail-item-wide:nth-last-child(-n+2) {
    border-bottom: 1px solid var(--ca-border-light, #e9edf3);
  }
  .detail-item-wide:last-child {
    border-bottom: 0;
  }
}
@media (prefers-reduced-motion: reduce) {
  .asset-details-backdrop, .asset-details-drawer, .drawer-close {
    transition-duration: 0.01ms !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/features/shared-workflows/data-asset-configuraion/data-asset-configuraion.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,cAAA;EACA,YAAA;EACA,sCAAA;AAEF;;AAEA;EACE,wBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,uCAAA;EACA,mBAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,wCAAA;EACA,gBAAA;AACF;;AAEA;EACE,iCAAA;EACA,kBAAA;AACF;;AAGA;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,4BAAA;AAAF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,YAAA;EACA,sBAAA;AACF;;AACA;EAAgB,YAAA;AAGhB;;AAFA;EACE,mBAAA;EACA,sCAAA;EACA,qCAAA;EACA,gBAAA;EACA,wBAAA;EACA,gBAAA;AAKF;;AAHA;EACE,SAAA;EACA,wCAAA;EACA,iBAAA;EACA,iBAAA;AAMF;;AAJA;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,iDAAA;EACA,uCAAA;EACA,mCAAA;EACA,gEAAA;AAOF;;AALA;EACE,aAAA;EACA,aAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,uCAAA;EACA,6CAAA;EACA,iCAAA;EACA,iBAAA;AAQF;;AANA;EAA0B,aAAA;EAAe,sBAAA;EAAwB,YAAA;AAYjE;;AAXA;EAA2B,sCAAA;EAAwC,iBAAA;EAAmB,gBAAA;AAiBtF;;AAhBA;EAAgD,uCAAA;EAAyC,kBAAA;EAAmB,mBAAA;AAsB5G;;AApBA;EACE,YAAA;EACA,gBAAA;EACA,iDAAA;EACA,wCAAA;EACA,mCAAA;EACA,gEAAA;AAuBF;;AArBA;EAAgB,mBAAA;AAyBhB;;AAxBA;EACE,sBAAA;EACA,uCAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;AA2BF;;AAzBA;EAAmB,kBAAA;EAAmB,sCAAA;EAAwC,kBAAA;EAAoB,gBAAA;AAgClG;;AA9BA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,uCAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,uFAAA;AAiCF;;AA/BA;EAAe,4CAAA;EAA8C,sCAAA;EAAwC,WAAA;AAqCrG;;AApCA;EAAoC,6CAAA;EAA+C,2CAAA;EAA6C,WAAA;AA0ChI;;AAzCA;EAAiB,2CAAA;EAA6C,mCAAA;EAAqC,iCAAA;AA+CnG;;AA9CA;EAAsC,wCAAA;EAA0C,4CAAA;AAmDhF;;AAlDA;EAA2D,0CAAA;EAA2C,mBAAA;AAuDtG;;AAtDA;EAAiD,mBAAA;EAAqB,YAAA;AA2DtE;;AAzDA;EACE,aAAA;EACA,sEAAA;EACA,YAAA;EACA,qBAAA;AA4DF;;AA1DA;EAAgB,aAAA;EAAe,YAAA;EAAc,oBAAA;AAgE7C;;AA/DA;EACE,WAAA;EAAa,YAAA;EAAc,mBAAA;EAC3B,iDAAA;EACA,uCAAA;EACA,oCAAA;EACA,sCAAA;EACA,mBAAA;AAoEF;;AAlEA;EAAwB,4CAAA;EAA8C,gDAAA;EAAgD,UAAA;AAwEtH;;AAvEA;EAA+B,oCAAA;AA2E/B;;AA1EA;EAAgC,0BAAA;EAA4B,6BAAA;AA+E5D;;AA9EA;EACE,oBAAA;EAAsB,cAAA;EAAgB,iBAAA;EAAmB,mBAAA;EACzD,4CAAA;EACA,oEAAA;EACA,sCAAA;EAAwC,WAAA;EAAa,eAAA;AAsFvD;;AApFA;EAAuB,2CAAA;AAwFvB;;AAvFA;EAAgB,mBAAA;AA2FhB;;AA1FA;EAAgB,YAAA;EAAc,gBAAA;AA+F9B;;AA9FA;EAA+B,cAAA;EAAgB,YAAA;AAmG/C;;AAlGA;EAAkB,aAAA;EAAe,kBAAA;EAAoB,mBAAA;EAAqB,YAAA;EAAa,wCAAA;EAA0C,mBAAA;AA2GjI;;AA1GA;EAAgB,aAAA;EAAe,mBAAA;EAAqB,8BAAA;EAAgC,eAAA;EAAiB,YAAA;EAAa,iBAAA;EAAkB,qBAAA;EAAsB,2CAAA;EAA6C,uCAAA;EAAyC,wCAAA;EAA0C,sCAAA;EAAwC,kBAAA;AAyHlU;;AAxHA;EAAgB,UAAA;EAAY,SAAA;EAAW,uBAAA;EAAyB,iCAAA;EAAmC,gBAAA;EAAkB,0BAAA;EAA4B,eAAA;AAkIjJ;;AAjIA;EAA0C,aAAA;EAAe,iBAAA;EAAmB,sBAAA;EAAwB,mBAAA;EAAqB,uBAAA;EAAyB,YAAA;EAAa,kBAAA;EAAoB,uCAAA;EAAyC,kBAAA;AA6I5N;;AA5IA;EAAoC,uCAAA;EAAyC,eAAA;AAiJ7E;;AAhJA;EAAmD,SAAA;EAAW,sCAAA;EAAwC,kBAAA;EAAoB,gBAAA;AAuJ1H;;AAtJA;EAAgD,gBAAA;EAAkB,kBAAA;EAAmB,wCAAA;EAA0C,iBAAA;EAAkB,gBAAA;AA8JjJ;;AA7JA;EAAmB,gCAAA;AAiKnB;;AAhKA;EAAe,4BAAA;AAoKf;;AAnKA;EAAuB,uBAAA;EAAyB,kBAAA;AAwKhD;;AAvKA;EAAoB,aAAA;EAAe,cAAA;EAAgB,eAAA;EAAiB,mBAAA;EAAqB,sBAAA;EAAwB,iDAAA;EAAmD,sBAAA;EAAwB,6CAAA;EAA+C,iCAAA;EAAmC,eAAA;AAoL9Q;;AAnLA;EAAkB,sBAAA;EAAuB,yCAAA;AAwLzC;;AAvLA;EAAiB,qBAAA;AA2LjB;;AA1LA;EAAsB,mBAAA;EAAqB,uBAAA;AA+L3C;;AA9LA;EAAmB,qBAAA;EAAuB,WAAA;EAAa,YAAA;EAAc,2CAAA;EAA6C,4CAAA;EAA8C,kBAAA;EAAoB,gDAAA;AAwMpL;;AAvMA;EAAsB,aAAA;EAAe,cAAA;EAAgB,iBAAA;AA6MrD;;AA5MA;EAAe,aAAA;EAAe,mBAAA;EAAqB,8BAAA;EAAgC,SAAA;EAAW,mBAAA;EAAqB,iBAAA;EAAmB,qDAAA;AAsNtI;;AArNA;EAAsB,uCAAA;EAAyC,kBAAA;AA0N/D;;AAzNA;EAA8B;IAAK,yBAAA;EA8NjC;AACF;AA7NA;EACE;IAAgB,uBAAA;IAAyB,sBAAA;EAiOzC;EAhOA;IAAkB,0DAAA;EAmOlB;EAlOA;IAAgB,iBAAA;IAAqB,mBAAA;EAsOrC;AACF;AArOA;EACE;IAAc,sBAAA;EAwOd;EAvOA;IAAqB,6BAAA;EA0OrB;EAzOA;IAAe,uBAAA;IAAyB,sBAAA;EA6OxC;EA5OA;IAAmB,iBAAA;EA+OnB;EA9OA;IAAkB,qCAAA;EAiPlB;EAhPA;IAAgB,iBAAA;IAAmB,mBAAA;EAoPnC;EAnPA;IAAe,oBAAA;IAAsB,sBAAA;EAuPrC;EAtPA;IAA8B,oBAAA;IAAsB,eAAA;EA0PpD;AACF;AAzPA;EACE;IAAyB,qCAAA;IAAsC,uCAAA;IAAyC,gCAAA;IAAkC,sCAAA;EA+P1I;AACF;AA7PA;;;8DAAA;AAIA;EACE,eAAA;EACA,QAAA;EACA,aAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,iCAAA;EACA,UAAA;EACA,kBAAA;EACA,eAAA;EACA,qDAAA;AA+PF;;AA7PA;EACE,UAAA;EACA,mBAAA;AAgQF;;AA9PA;EACE,eAAA;EACA,aAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;EACA,wBAAA;EACA,eAAA;EACA,sBAAA;EACA,gBAAA;EACA,sDAAA;EACA,mCAAA;EACA,8CAAA;EACA,2BAAA;EACA,kBAAA;EACA,mFAAA;AAiQF;;AA/PA;EACE,wBAAA;EACA,mBAAA;AAkQF;;AAhQA;EACE,aAAA;EACA,cAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,8BAAA;EACA,wDAAA;EACA,0DAAA;AAmQF;;AAjQA;EAAkB,aAAA;EAAe,YAAA;EAAc,uBAAA;EAAyB,YAAA;AAwQxE;;AAvQA;EACE,aAAA;EACA,aAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,iDAAA;EACA,qBAAA;EACA,6CAAA;EACA,iCAAA;EACA,iBAAA;AA0QF;;AAxQA;EACE,mBAAA;EACA,uCAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;AA2QF;;AAzQA;EAAqB,mBAAA;EAAoB,sCAAA;EAAwC,kBAAA;EAAoB,gBAAA;AAgRrG;;AA/QA;EAAmB,SAAA;EAAW,uCAAA;EAAyC,kBAAA;EAAmB,iBAAA;AAsR1F;;AArRA;EACE,aAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,2CAAA;EACA,sBAAA;EACA,gBAAA;EACA,wCAAA;EACA,eAAA;EACA,kFAAA;AAwRF;;AAtRA;EAAsB,wCAAA;EAA0C,6CAAA;EAA+C,iCAAA;AA4R/G;;AA3RA;EAAe,aAAA;EAAe,cAAA;EAAgB,gBAAA;EAAkB,+BAAA;AAkShE;;AAjSA;EAAgB,aAAA;EAAe,iBAAA;EAAmB,sBAAA;EAAwB,mBAAA;EAAqB,uBAAA;EAAyB,YAAA;EAAa,eAAA;EAAiB,wCAAA;EAA0C,kBAAA;AA6ShM;;AA5SA;EAAyB,sCAAA;EAAwC,kBAAA;AAiTjE;;AAhTA;EAAkB,gBAAA;EAAkB,SAAA;EAAW,uCAAA;EAAyC,kBAAA;EAAmB,gBAAA;AAwT3G;;AAvTA;EAAqB,aAAA;EAAe,WAAA;EAAa,YAAA;EAAc,mBAAA;EAAqB,qBAAA;EAAsB,mBAAA;EAAqB,wCAAA;EAA0C,gCAAA;EAAkC,iBAAA;AAmU3M;;AAlUA;EAAmB,SAAA;EAAW,sCAAA;EAAwC,eAAA;EAAiB,gBAAA;AAyUvF;;AAxUA;EACE,aAAA;EACA,0CAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,iDAAA;EACA,wCAAA;EACA,sDAAA;AA2UF;;AAzUA;EAAgB,aAAA;EAAe,cAAA;EAAgB,eAAA;EAAiB,mBAAA;EAAqB,qBAAA;EAAsB,6CAAA;EAA+C,iCAAA;EAAmC,kBAAA;AAoV7L;;AAnVA;EAAqB,YAAA;AAuVrB;;AAtVA;EAAwB,wBAAA;EAAwB,sCAAA;EAAwC,kBAAA;EAAoB,gBAAA;EAAkB,uBAAA;AA8V9H;;AA7VA;EAAuB,SAAA;EAAW,wCAAA;EAA0C,kBAAA;EAAmB,iBAAA;EAAmB,uBAAA;AAqWlH;;AApWA;EAA8B,cAAA;EAAgB,mBAAA;EAAqB,wBAAA;EAAwB,oBAAA;EAAsB,kBAAA;EAAmB,gBAAA;EAAkB,uBAAA;AA8WtJ;;AA7WA;EAAyC,yCAAA;EAA2C,iCAAA;AAkXpF;;AAjXA;EAA6C,yCAAA;EAA2C,cAAA;AAsXxF;;AArXA;EAAmB,mBAAA;EAAqB,gBAAA;EAAkB,iDAAA;EAAmD,wCAAA;EAA0C,mCAAA;AA6XvJ;;AA5XA;EAA2B,aAAA;EAAe,mBAAA;EAAqB,WAAA;EAAY,qBAAA;AAmY3E;;AAlYA;EAAwB,aAAA;EAAe,aAAA;EAAe,cAAA;EAAgB,gBAAA;EAAkB,mBAAA;EAAqB,sBAAA;EAAuB,6CAAA;EAA+C,iCAAA;EAAmC,kBAAA;AA8YtN;;AA7YA;EAA8B,mBAAA;EAAoB,sCAAA;EAAwC,iBAAA;EAAkB,gBAAA;AAoZ5G;;AAnZA;EAA6B,SAAA;EAAW,uCAAA;EAAyC,kBAAA;AAyZjF;;AAxZA;EAAuB,aAAA;EAAe,gDAAA;EAAkD,YAAA;AA8ZxF;;AA7ZA;EAAiB,aAAA;EAAe,YAAA;EAAc,sBAAA;EAAwB,WAAA;EAAY,gBAAA;EAAiB,iDAAA;EAAmD,uCAAA;EAAyC,iCAAA;AAwa/L;;AAvaA;EAAsB,uCAAA;EAAyC,kBAAA;EAAmB,gBAAA;AA6alF;;AA5aA;EAAwB,iCAAA;EAAmC,kBAAA;EAAoB,gBAAA;EAAkB,uBAAA;AAmbjG;;AAlbA;EAAgB,aAAA;EAAe,gDAAA;EAAkD,aAAA;EAAc,SAAA;AAyb/F;;AAxbA;EAAe,YAAA;EAAc,kBAAA;EAAmB,wDAAA;AA8bhD;;AA7bA;EAAsC,gBAAA;AAictC;;AAhcA;EAAkB,qBAAA;EAAsB,uCAAA;EAAyC,iBAAA;EAAkB,gBAAA;AAucnG;;AAtcA;EAAkB,SAAA;EAAW,sCAAA;EAAwC,kBAAA;EAAmB,gBAAA;EAAkB,iBAAA;EAAmB,uBAAA;AA+c7H;;AA9cA;EAAoB,iBAAA;AAkdpB;;AAjdA;EAA2C,wDAAA;AAqd3C;;AApdA;EAAa,mDAAA;EAAqD,6BAAA;EAA8B,2BAAA;EAA6B,qBAAA;AA2d7H;;AA1dA;EAAiB,aAAA;EAAe,cAAA;EAAgB,yBAAA;EAA2B,wBAAA;EAAyB,qDAAA;EAAuD,gBAAA;AAme3J;;AAleA;EAAsB,eAAA;AAsetB;;AApeA;EACE;IAAwB,YAAA;EAwexB;EAveA;IAAiB,aAAA;EA0ejB;EAzeA;IAAe,eAAA;EA4ef;EA3eA;IAAiB,sBAAA;EA8ejB;EA7eA;IAAmB,gBAAA;EAgfnB;EA/eA;IAAgB,qCAAA;EAkfhB;EAjfA;IAAsC,wDAAA;EAoftC;EAnfA;IAA0B,gBAAA;EAsf1B;EArfA;IAAoB,iBAAA;EAwfpB;EAvfA;IAA2C,wDAAA;EA0f3C;EAzfA;IAA+B,gBAAA;EA4f/B;AACF;AA3fA;EACE;IAAgE,sCAAA;EA8fhE;AACF","sourcesContent":[":host {\n  display: block;\n  min-width: 0;\n  color: var(--ca-text-primary, #172033);\n}\n\n\n.breadcrumb {\n  margin: 1.25rem 1.5rem 0;\n}\n\n.breadcrumb-nav {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin: 0 0 0.75rem;\n  color: var(--ca-text-tertiary, #6f7b91);\n  font-size: 0.875rem;\n}\n\n.breadcrumb-current {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n  color: var(--ca-text-secondary, #4b5870);\n  font-weight: 500;\n}\n\n.breadcrumb-current i {\n  color: var(--ca-primary, #0e2e80);\n  font-size: 1.25rem;\n}\n\n\n.asset-config-page {\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  margin: 0 auto;\n  padding: 1rem 1.5rem 1.75rem;\n}\n.page-header, .list-heading {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1.25rem;\n  margin-bottom: 1.25rem;\n}\n.page-heading { min-width: 0; }\n.page-heading h1 {\n  margin: 0 0 .35rem;\n  color: var(--ca-text-primary, #172033);\n  font-size: clamp(1.4rem, 2vw, 1.8rem);\n  font-weight: 700;\n  letter-spacing: -.025em;\n  line-height: 1.3;\n}\n.page-heading p, .list-heading p {\n  margin: 0;\n  color: var(--ca-text-secondary, #4b5870);\n  font-size: .9rem;\n  line-height: 1.55;\n}\n.page-header-meta {\n  display: flex;\n  flex: 0 0 auto;\n  align-items: center;\n  gap: .75rem;\n  min-width: 10.5rem;\n  padding: .7rem .9rem;\n  border: 1px solid var(--ca-border-light, #e9edf3);\n  border-radius: var(--ca-radius-md, 8px);\n  background: var(--ca-surface, #fff);\n  box-shadow: var(--ca-shadow-sm, 0 2px 6px rgba(7, 17, 46, .06));\n}\n.header-meta-icon {\n  display: grid;\n  width: 2.4rem;\n  height: 2.4rem;\n  flex: 0 0 2.4rem;\n  place-items: center;\n  border-radius: var(--ca-radius-sm, 6px);\n  background: var(--ca-surface-active, #eef3ff);\n  color: var(--ca-primary, #0e2e80);\n  font-size: 1.1rem;\n}\n.page-header-meta > div { display: flex; flex-direction: column; min-width: 0; }\n.page-header-meta strong { color: var(--ca-text-primary, #172033); font-size: 1.1rem; line-height: 1.2; }\n.page-header-meta span:not(.header-meta-icon) { color: var(--ca-text-tertiary, #6f7b91); font-size: .72rem; white-space: nowrap; }\n\n.asset-list-card {\n  min-width: 0;\n  padding: 1.25rem;\n  border: 1px solid var(--ca-border-light, #e9edf3);\n  border-radius: var(--ca-radius-lg, 12px);\n  background: var(--ca-surface, #fff);\n  box-shadow: var(--ca-shadow-sm, 0 2px 6px rgba(7, 17, 46, .06));\n}\n.list-heading { align-items: center; }\n.section-eyebrow {\n  margin-bottom: .35rem;\n  color: var(--ca-primary-light, #2850ad);\n  font-size: .68rem;\n  font-weight: 800;\n  letter-spacing: .1em;\n}\n.list-heading h2 { margin: 0 0 .3rem; color: var(--ca-text-primary, #172033); font-size: 1.15rem; font-weight: 700; }\n\n.btn-primary, .btn-secondary {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: .5rem;\n  min-height: 2.6rem;\n  padding: .65rem 1rem;\n  border-radius: var(--ca-radius-md, 8px);\n  font-size: .875rem;\n  font-weight: 600;\n  line-height: 1.25;\n  white-space: nowrap;\n  transition: background-color .15s ease, border-color .15s ease, box-shadow .15s ease;\n}\n.btn-primary { border: 1px solid var(--ca-primary, #0e2e80); background: var(--ca-primary, #0e2e80); color: #fff; }\n.btn-primary:hover:not(:disabled) { border-color: var(--ca-primary-dark, #0d2863); background: var(--ca-primary-dark, #0d2863); color: #fff; }\n.btn-secondary { border: 1px solid var(--ca-border, #dfe4ec); background: var(--ca-surface, #fff); color: var(--ca-primary, #0e2e80); }\n.btn-secondary:hover:not(:disabled) { border-color: var(--ca-primary, #0e2e80); background: var(--ca-surface-hover, #f8faff); }\n.btn-primary:focus-visible, .btn-secondary:focus-visible { outline: 3px solid rgba(40, 80, 173, .25); outline-offset: 2px; }\n.btn-primary:disabled, .btn-secondary:disabled { cursor: not-allowed; opacity: .6; }\n\n.search-toolbar {\n  display: grid;\n  grid-template-columns: minmax(16rem, 1.5fr) minmax(13rem, .85fr) auto;\n  gap: .75rem;\n  margin-bottom: 1.1rem;\n}\n.search-field { display: flex; min-width: 0; align-items: stretch; }\n.search-control {\n  width: 100%; min-width: 0; min-height: 2.65rem;\n  border: 1px solid var(--ca-input-border, #dfe4ec);\n  border-radius: var(--ca-radius-md, 8px);\n  background: var(--ca-input-bg, #fff);\n  color: var(--ca-text-primary, #172033);\n  font-size: .875rem;\n}\n.search-control:focus { border-color: var(--ca-input-focus, #2850ad); box-shadow: 0 0 0 .2rem rgba(40, 80, 173, .15); outline: 0; }\n.search-control::placeholder { color: var(--ca-text-muted, #8c96a8); }\n.search-field .search-control { border-top-right-radius: 0; border-bottom-right-radius: 0; }\n.search-submit {\n  display: inline-grid; width: 2.75rem; flex: 0 0 2.75rem; place-items: center;\n  border: 1px solid var(--ca-primary, #0e2e80);\n  border-radius: 0 var(--ca-radius-md, 8px) var(--ca-radius-md, 8px) 0;\n  background: var(--ca-primary, #0e2e80); color: #fff; cursor: pointer;\n}\n.search-submit:hover { background: var(--ca-primary-dark, #0d2863); }\n.clear-search { align-self: stretch; }\n.table-region { min-width: 0; overflow-x: auto; }\n.table-region app-main-table { display: block; min-width: 0; }\n.inline-loading { display: flex; min-height: 4.5rem; align-items: center; gap: .65rem; color: var(--ca-text-secondary, #4b5870); font-size: .875rem; }\n.inline-error { display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: .75rem; margin: .75rem 0; padding: .85rem 1rem; border: 1px solid var(--ca-danger, #dc3545); border-radius: var(--ca-radius-md, 8px); background: var(--ca-danger-bg, #fdecef); color: var(--ca-text-primary, #172033); font-size: .85rem; }\n.inline-retry { padding: 0; border: 0; background: transparent; color: var(--ca-primary, #0e2e80); font-weight: 700; text-decoration: underline; cursor: pointer; }\n.state-panel, .no-results, .empty-state { display: flex; min-height: 15rem; flex-direction: column; align-items: center; justify-content: center; gap: .65rem; padding: 2rem 1rem; color: var(--ca-text-tertiary, #6f7b91); text-align: center; }\n.state-panel > i, .no-results > i { color: var(--ca-primary-light, #2850ad); font-size: 2rem; }\n.state-panel h2, .no-results h3, .empty-state h2 { margin: 0; color: var(--ca-text-primary, #172033); font-size: 1.15rem; font-weight: 700; }\n.state-panel p, .no-results p, .empty-state p { max-width: 35rem; margin: 0 0 .5rem; color: var(--ca-text-secondary, #4b5870); font-size: .9rem; line-height: 1.6; }\n.error-state > i { color: var(--ca-danger, #dc3545); }\n.empty-state { min-height: min(60vh, 40rem); }\n.empty-state-content { width: min(100%, 42rem); text-align: center; }\n.empty-state-icon { display: grid; width: 4.25rem; height: 4.25rem; place-items: center; margin: 0 auto 1.25rem; border: 1px solid var(--ca-border-light, #e9edf3); border-radius: 1.25rem; background: var(--ca-surface-active, #eef3ff); color: var(--ca-primary, #0e2e80); font-size: 2rem; }\n.empty-state h2 { margin-bottom: .65rem; font-size: clamp(1.35rem, 2.5vw, 1.75rem); }\n.empty-state p { margin: 0 auto 1.5rem; }\n.empty-state-action { min-height: 2.85rem; padding-inline: 1.25rem; }\n.loading-spinner { display: inline-block; width: 2rem; height: 2rem; border: 3px solid var(--ca-border, #dfe4ec); border-top-color: var(--ca-primary, #0e2e80); border-radius: 50%; animation: data-config-spin .8s linear infinite; }\n.loading-spinner-sm { width: 1.1rem; height: 1.1rem; border-width: 2px; }\n.list-footer { display: flex; align-items: center; justify-content: space-between; gap: 1rem; margin-top: 1.15rem; padding-top: 1rem; border-top: 1px solid var(--ca-border-light, #e9edf3); }\n.pagination-summary { color: var(--ca-text-tertiary, #6f7b91); font-size: .78rem; }\n@keyframes data-config-spin { to { transform: rotate(360deg); } }\n\n@media (max-width: 1100px) {\n  .list-heading { align-items: flex-start; flex-direction: column; }\n  .search-toolbar { grid-template-columns: minmax(0, 1fr) minmax(12rem, .8fr); }\n  .clear-search { grid-column: 1 / -1; justify-self: start; }\n}\n@media (max-width: 767.98px) {\n  .breadcrumb { margin: .75rem 1rem 0; }\n  .asset-config-page { padding: .75rem 1rem 1.25rem; }\n  .page-header { align-items: flex-start; flex-direction: column; }\n  .asset-list-card { padding: .875rem; }\n  .search-toolbar { grid-template-columns: minmax(0, 1fr); }\n  .clear-search { grid-column: auto; justify-self: start; }\n  .list-footer { align-items: stretch; flex-direction: column; }\n  .list-footer app-pagination { align-self: flex-end; max-width: 100%; }\n}\n@media (prefers-reduced-motion: reduce) {\n  *, *::before, *::after { animation-duration: .01ms !important; animation-iteration-count: 1 !important; scroll-behavior: auto !important; transition-duration: .01ms !important; }\n}\n\n/* =========================================================\n   DATA ASSET DETAILS — RIGHT-SIDE SLIDE PANEL\n   Uses the global Consult-AI design tokens from styles.scss.\n   ========================================================= */\n.asset-details-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 1090;\n  display: block;\n  width: 100%;\n  height: 100%;\n  padding: 0;\n  border: 0;\n  background: rgba(4, 27, 56, 0.48);\n  opacity: 0;\n  visibility: hidden;\n  cursor: default;\n  transition: opacity .24s ease, visibility .24s ease;\n}\n.asset-details-backdrop.is-open {\n  opacity: 1;\n  visibility: visible;\n}\n.asset-details-drawer {\n  position: fixed;\n  z-index: 1091;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  width: min(600px, 100vw);\n  max-width: 100%;\n  flex-direction: column;\n  overflow: hidden;\n  border-left: 1px solid var(--ca-border-light, #e9edf3);\n  background: var(--ca-surface, #fff);\n  box-shadow: -14px 0 42px rgba(7, 17, 46, .18);\n  transform: translateX(105%);\n  visibility: hidden;\n  transition: transform .28s cubic-bezier(.2, .75, .25, 1), visibility .28s ease;\n}\n.asset-details-drawer.is-open {\n  transform: translateX(0);\n  visibility: visible;\n}\n.drawer-header {\n  display: flex;\n  flex: 0 0 auto;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 1.35rem 1.4rem 1.1rem;\n  border-bottom: 1px solid var(--ca-border-light, #e9edf3);\n  background: linear-gradient(180deg, #fff 0%, #fbfcff 100%);\n}\n.drawer-heading { display: flex; min-width: 0; align-items: flex-start; gap: .85rem; }\n.drawer-heading-icon {\n  display: grid;\n  width: 2.8rem;\n  height: 2.8rem;\n  flex: 0 0 2.8rem;\n  place-items: center;\n  border: 1px solid var(--ca-border-light, #e9edf3);\n  border-radius: .8rem;\n  background: var(--ca-surface-active, #eef3ff);\n  color: var(--ca-primary, #0e2e80);\n  font-size: 1.2rem;\n}\n.drawer-eyebrow {\n  margin: 0 0 .25rem;\n  color: var(--ca-primary-light, #2850ad);\n  font-size: .64rem;\n  font-weight: 800;\n  letter-spacing: .12em;\n}\n.drawer-heading h2 { margin: 0 0 .25rem; color: var(--ca-text-primary, #172033); font-size: 1.22rem; font-weight: 750; }\n.drawer-subtitle { margin: 0; color: var(--ca-text-tertiary, #6f7b91); font-size: .78rem; line-height: 1.45; }\n.drawer-close {\n  display: grid;\n  width: 2.35rem;\n  height: 2.35rem;\n  flex: 0 0 2.35rem;\n  place-items: center;\n  border: 1px solid var(--ca-border, #dfe4ec);\n  border-radius: .65rem;\n  background: #fff;\n  color: var(--ca-text-secondary, #4b5870);\n  cursor: pointer;\n  transition: background-color .15s ease, color .15s ease, border-color .15s ease;\n}\n.drawer-close:hover { border-color: var(--ca-primary, #0e2e80); background: var(--ca-surface-active, #eef3ff); color: var(--ca-primary, #0e2e80); }\n.drawer-body { min-height: 0; flex: 1 1 auto; overflow-y: auto; padding: 1.15rem 1.35rem 1.5rem; }\n.drawer-state { display: flex; min-height: 14rem; flex-direction: column; align-items: center; justify-content: center; gap: .65rem; padding: 1.5rem; color: var(--ca-text-secondary, #4b5870); text-align: center; }\n.drawer-state > strong { color: var(--ca-text-primary, #172033); font-size: .95rem; }\n.drawer-state p { max-width: 20rem; margin: 0; color: var(--ca-text-tertiary, #6f7b91); font-size: .82rem; line-height: 1.5; }\n.drawer-state-icon { display: grid; width: 3rem; height: 3rem; place-items: center; margin-bottom: .2rem; border-radius: 1rem; background: var(--ca-danger-bg, #fdecef); color: var(--ca-danger, #dc3545); font-size: 1.3rem; }\n.drawer-state h3 { margin: 0; color: var(--ca-text-primary, #172033); font-size: 1rem; font-weight: 700; }\n.details-hero {\n  display: grid;\n  grid-template-columns: auto minmax(0, 1fr);\n  align-items: start;\n  gap: .85rem;\n  padding: 1rem;\n  border: 1px solid var(--ca-border-light, #e9edf3);\n  border-radius: var(--ca-radius-lg, 12px);\n  background: linear-gradient(135deg, #f8faff, #fff 80%);\n}\n.asset-avatar { display: grid; width: 2.65rem; height: 2.65rem; place-items: center; border-radius: .8rem; background: var(--ca-surface-active, #eef3ff); color: var(--ca-primary, #0e2e80); font-size: 1.25rem; }\n.details-hero-copy { min-width: 0; }\n.details-hero-copy h3 { margin: .1rem 0 .35rem; color: var(--ca-text-primary, #172033); font-size: 1.05rem; font-weight: 750; overflow-wrap: anywhere; }\n.details-hero-copy p { margin: 0; color: var(--ca-text-secondary, #4b5870); font-size: .82rem; line-height: 1.55; overflow-wrap: anywhere; }\n.configuration-status-badge { grid-column: 2; justify-self: start; padding: .32rem .65rem; border-radius: 999px; font-size: .68rem; font-weight: 750; letter-spacing: .025em; }\n.configuration-status-badge.configured { background: var(--ca-success-bg, #eaf7f0); color: var(--ca-success, #198754); }\n.configuration-status-badge.not-configured { background: var(--ca-warning-bg, #fff7e6); color: #9a6500; }\n.details-section { margin-top: 1.15rem; padding: 1.05rem; border: 1px solid var(--ca-border-light, #e9edf3); border-radius: var(--ca-radius-lg, 12px); background: var(--ca-surface, #fff); }\n.details-section-heading { display: flex; align-items: center; gap: .7rem; margin-bottom: .9rem; }\n.details-section-icon { display: grid; width: 2.1rem; height: 2.1rem; flex: 0 0 2.1rem; place-items: center; border-radius: .65rem; background: var(--ca-surface-active, #eef3ff); color: var(--ca-primary, #0e2e80); font-size: .95rem; }\n.details-section-heading h3 { margin: 0 0 .15rem; color: var(--ca-text-primary, #172033); font-size: .9rem; font-weight: 750; }\n.details-section-heading p { margin: 0; color: var(--ca-text-tertiary, #6f7b91); font-size: .73rem; }\n.details-metric-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: .75rem; }\n.detail-metric { display: flex; min-width: 0; flex-direction: column; gap: .4rem; padding: .85rem; border: 1px solid var(--ca-border-light, #e9edf3); border-radius: var(--ca-radius-md, 8px); background: var(--ca-bg, #f5f7fb); }\n.detail-metric span { color: var(--ca-text-tertiary, #6f7b91); font-size: .75rem; font-weight: 600; }\n.detail-metric strong { color: var(--ca-primary, #0e2e80); font-size: 1.35rem; line-height: 1.2; overflow-wrap: anywhere; }\n.details-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 0 .9rem; margin: 0; }\n.detail-item { min-width: 0; padding: .72rem 0; border-bottom: 1px solid var(--ca-border-light, #e9edf3); }\n.detail-item:nth-last-child(-n + 2) { border-bottom: 0; }\n.detail-item dt { margin-bottom: .3rem; color: var(--ca-text-tertiary, #6f7b91); font-size: .7rem; font-weight: 600; }\n.detail-item dd { margin: 0; color: var(--ca-text-primary, #172033); font-size: .82rem; font-weight: 650; line-height: 1.45; overflow-wrap: anywhere; }\n.detail-item-wide { grid-column: 1 / -1; }\n.detail-item-wide:nth-last-child(-n + 2) { border-bottom: 1px solid var(--ca-border-light, #e9edf3); }\n.detail-id { color: var(--ca-text-secondary, #4b5870) !important; font-size: .73rem !important; font-weight: 500 !important; word-break: break-all; }\n.drawer-footer { display: flex; flex: 0 0 auto; justify-content: flex-end; padding: .85rem 1.35rem; border-top: 1px solid var(--ca-border-light, #e9edf3); background: #fff; }\n.drawer-footer .btn { min-width: 6rem; }\n\n@media (max-width: 575.98px) {\n  .asset-details-drawer { width: 100vw; }\n  .drawer-header { padding: 1rem; }\n  .drawer-body { padding: .9rem; }\n  .drawer-footer { padding: .8rem .9rem; }\n  .details-section { padding: .85rem; }\n  .details-grid { grid-template-columns: minmax(0, 1fr); }\n  .detail-item:nth-last-child(-n + 2) { border-bottom: 1px solid var(--ca-border-light, #e9edf3); }\n  .detail-item:last-child { border-bottom: 0; }\n  .detail-item-wide { grid-column: auto; }\n  .detail-item-wide:nth-last-child(-n + 2) { border-bottom: 1px solid var(--ca-border-light, #e9edf3); }\n  .detail-item-wide:last-child { border-bottom: 0; }\n}\n@media (prefers-reduced-motion: reduce) {\n  .asset-details-backdrop, .asset-details-drawer, .drawer-close { transition-duration: .01ms !important; }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
